(() => {
  const markers = new Map();
  const mobile = window.matchMedia('(max-width: 749px)');

  function remember(node) {
    if (!node || markers.has(node)) return;
    const marker = document.createComment('mb-original-position');
    node.parentNode.insertBefore(marker, node);
    markers.set(node, marker);
  }

  function move(node, slot) {
    if (!node || !slot || slot.contains(node)) return;
    remember(node);
    slot.appendChild(node);
  }

  function restore(node) {
    const marker = markers.get(node);
    if (node && marker?.parentNode) marker.parentNode.insertBefore(node, marker.nextSibling);
  }

  function findStorySection() {
    return [...document.querySelectorAll('.mb-reviews-central-section')]
      .find(section => section.querySelector('.mb-reviews--stories'));
  }

  function arrangeProduct() {
    const story = findStorySection();
    const delivery = document.querySelector('.mb-delivery-section')?.closest('.shopify-section');
    const limited = document.querySelector('.mb-limited-section')?.closest('.shopify-section');

    if (mobile.matches) {
      move(story, document.querySelector('[data-mb-product-stories-slot]'));
      move(delivery, document.querySelector('[data-mb-product-delivery-slot]'));
      move(limited, document.querySelector('[data-mb-product-limited-slot]'));
    } else {
      [story, delivery, limited].forEach(restore);
    }
  }

  const schedule = () => requestAnimationFrame(arrangeProduct);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', schedule, { once: true })
    : schedule();
  mobile.addEventListener?.('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
})();
